export default __webpack_public_path__ + "static/media/template30.a1d2168e.svg";